import React from 'react';

const NotFound = () => <div>404 - NotFound</div>;

export default NotFound;
